import { clsx } from "clsx"
import { twMerge } from "tailwind-merge"

// This used by tailwind. no need to touch this file or edit anything.
export function cn(...inputs) {
  return twMerge(clsx(inputs))
}
